module.exports = __webpack_public_path__ + "roboto-italic-webfont.03ba22771d27eb3eae6d.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/roboto-italic-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto-italic-webfont.ttf
// module chunks = styles